import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import ASSETS from '../../assets';
import { useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import Pagination from '../../components/Pagination/Pagination';

dayjs.extend(utc);
dayjs.extend(relativeTime);

const Blocks = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { blocksData, pages } = useSelector(state => state.blocks);

  const [page, setPage] = useState(1);

  const handleClick = block => {
    navigate(`/block/${block?.block_number}`);
  };

  useEffect(() => {
    dispatch.blocks.getBlockWithPagination(page);
    // eslint-disable-next-line
  }, [page]);

  return (
    <div className='p-5'>
      {/* table section */}
      {/* table */}
      <div className='bg-white  border border-bryt-grey-200 rounded-[12px] shadow-txBox mt-3'>
        <div className='flex items-center justify-between py-5 px-[17px]'>
          <div className='flex items-center gap-2'>
            <div className='flex items-center gap-[6px] border border-bryt-grey-200 h-[29px] px-[10px] rounded-md cursor-not-allowed'>
              <img src={ASSETS.download} alt='' />
              <p className='text-[12.5px]'> Download Page Data</p>
            </div>
            <div className='flex items-center gap-[6px] border border-bryt-grey-200 h-[29px] px-[10px] rounded-md cursor-not-allowed'>
              <img src={ASSETS.cone} alt='' />
              <img src={ASSETS.arrowDown} alt='' />
            </div>
          </div>
        </div>
        <div className='w-full overflow-auto'>
          <table className='w-full border-collapse'>
            <thead>
              <tr className='bg-bryt-primary-main h-[38px] [&_td]:px-4'>
                <td className='text-[12.5px] font-bold text-white'>
                  Block Number
                </td>
                <td className='text-[12.5px] font-bold text-white'>
                  Transactions count
                </td>
                <td className='text-[12.5px] font-bold text-white'>
                  Block Hash
                </td>
                <td className='text-[12.5px] font-bold text-white'>
                  Timestamp
                </td>
              </tr>
            </thead>
            <tbody>
              {blocksData?.map(block => (
                <tr
                  key={block.block_number}
                  className='h-12 [&_td]:px-4 [&_td]:border-b [&_td]:border-b-bryt-grey-200
                [&:last-of-type_td]:border-b-0 cursor-pointer'
                  onClick={() => handleClick(block)}
                >
                  <td className='text-[14.5px] text-bryt-primary-main'>
                    {block?.block_number}
                  </td>
                  <td className='text-[14.5px] text-bryt-primary-main'>
                    {block?.transactions?.length || 0}
                  </td>
                  <td className='text-[14.5px] text-bryt-primary-main'>
                    {block.block_hash ||
                      '0x0000000000000000000000000000000000000000'}
                  </td>
                  <td className='text-[14.5px] text-bryt-primary-main capitalize'>
                    {dayjs.unix(block?.timestamp).fromNow()}
                    {' -- '} (
                    {dayjs.unix(block?.timestamp).format('DD MMM, YYYY h:mm A')}
                    )
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination pages={pages} page={page} setPage={setPage} />
      <div className='flex justify-end'>
        <div className='flex items-center gap-1 mt-[10px]'>
          <p className='text-[11.6px]'>
            [ Download:{' '}
            <span className='font-semibold text-bryt-primary-main '>
              CSV Export
            </span>{' '}
          </p>
          <img src={ASSETS.download} alt='' />
          <p className='text-[11.6px]'> ]</p>
        </div>
      </div>
      <div className='flex items-start gap-[14.5px] mt-[14px]'>
        <img src={ASSETS.bulb} alt='' />
        <p className='text-[12.5px] text-bryt-grey-700'>
          Blocks are batches of transactions linked via cryptographic hashes.
          Any tampering of a block would invalidate all following blocks as all
          subsequent hashes would change. Learn more about this page in our{' '}
          <span className='text-bryt-primary-main'>Knowledge Base</span>
        </p>
      </div>
    </div>
  );
};

export default Blocks;
